export default {
  'activities.title': '用户活动',

  'activities.filter.range': '按时间段查询',

  'activities.columns.created_at': '创建时间',
  'activities.columns.type': '类型',
  'activities.columns.purpose': '目的',
  'activities.columns.employee': '员工',
};
